import {actions as A} from '../../constants/actions';

export const appendStepData = payload => {
  return (dispatch) => {
    dispatch({
      type: A.APPEND_SHUMA_STEP_DATA,
      payload,
    });
  };
};
